export enum zIndexes {
  floatingPanel = 300,
  topBar = 200,
  exportMenu = 150,
  notesPopover = 100,
  titleBar = 10,
  popovers = 8,
  sideBar = 5,
  content = 2,
}
